import moment from 'moment'
import { clickCollectInstance } from '.'
import { CCpostPathes } from '../ApiPOSTPathes'
import { getUserData } from 'featureSliced/shared/utils/getUserData'
import { handleLocalStorage } from 'featureSliced/shared/utils/handleLocalStorage'
import { subscribeForNotifications } from 'featureSliced/shared/utils/webPush/initializeState'
import { isSupported } from 'firebase/messaging'
import { WalletPathes } from '../ApiGETPathes'
import {
  CreateOrderTypeCC,
  RefillCompleteType,
  RefillRequestType,
} from './types'
import { ProductToPay } from 'sections/Payment/types'

const withToken = true
export class clickCollectPOST {
  public static async createCustomerCard() {
    const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
    const res = await clickCollectInstance.post(
      CCpostPathes.CREATE_CARD,
      {
        company: guid,
        data: dataEnc,
      },
      withToken
    )
    return res
  }

  public static async transferCustomerCard(
    loyaltyNumber: string,
    accessCode: string,
    lastTransaction: string
  ) {
    const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
    const res = await clickCollectInstance.post(
      CCpostPathes.TRANSFER_CARD,
      {
        company: guid,
        data: dataEnc,
        cardNumber: loyaltyNumber,
        accessCode,
        lastTransaction,
      },
      withToken
    )
    return res
  }

  public static async refillCardRequest(
    amount: number,
    useNewCard: boolean,
    updateActiveCard: boolean,
    shopId?: string, // for HS-Pay only
    hsPaymentData?: any // for HS-Pay only
  ) {
    const { guid, registerId, dataEnc } = handleLocalStorage([
      'guid',
      'registerId',
      'dataEnc',
    ])
    const res: RefillRequestType = await clickCollectInstance.post(
      CCpostPathes.REQUEST_CARD_REFILL,
      {
        company: guid,
        data: dataEnc,
        register: registerId,
        amount,
        useNewCard,
        updateActiveCard,
        shopId,
        hsPaymentData,
      },
      withToken
    )
    return res
  }

  public static async refillCardRequestWallet(amount: number, cardId: string) {
    const { guid, registerId, dataEnc } = handleLocalStorage([
      'guid',
      'registerId',
      'dataEnc',
    ])
    const result: any = await clickCollectInstance.post(
      WalletPathes.START_CARD_REFILL,
      {
        company: guid,
        data: dataEnc,
        register: registerId,
        amount,
        cardId,
      }
    )
    return result
  }

  public static async refillCardComplete(
    transactionId: string | null = null,
    orderGuid: string | null = null,
    redirectResult?: string | null
  ) {
    const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
    const res: RefillCompleteType = await clickCollectInstance.post(
      CCpostPathes.COMPLETE_CARD_REFILL,
      {
        company: guid,
        data: dataEnc,
        transactionId,
        orderGuid,
        redirectResult,
      },
      withToken
    )
    return !!res.message
    // return !!res.message && !!res.receiptNr
  }

  public static async refillCardCompleteWallet(
    transactionId: string | null,
    orderGuid: string | null,
    cardId: string | null
  ) {
    const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
    const res: RefillCompleteType = await clickCollectInstance.post(
      WalletPathes.COMPLETE_CARD_REFILL,
      {
        company: guid,
        data: dataEnc,
        transactionId,
        orderGuid,
        cardId,
      }
    )
    return !!res.message && !!res.receiptNr
  }

  public static async paymentComplete(
    transactionId: string,
    orderGUID: string
  ) {
    const result: any = await clickCollectInstance.post(
      CCpostPathes.COMPLETE_ORDER_PAYMENT,
      {
        transactionId,
        orderGUID,
      }
    )
    return result
  }

  public static async createOrder(
    choosenProducts?: ProductToPay[],
    useNewCard = false,
    updateActiveCard = false,
    useCustomerCard = false,
    name = '',
    phoneNumber = ''
  ) {
    const {
      guid,
      dataEnc,
      registerId,
      // selfServiceName,
      // selfServicePhone,
      pickUpTime,
    } = handleLocalStorage([
      'guid',
      'dataEnc',
      'registerId',
      // 'selfServiceName',
      // 'selfServicePhone',
      'pickUpTime',
    ])
    const sessionId = handleLocalStorage('sessionId')
    const pickupTime = pickUpTime || moment().utc().format()
    const currentUserInfo = await getUserData()
    const result: CreateOrderTypeCC = await clickCollectInstance.post(
      CCpostPathes.CREATE_ORDER,
      {
        company: guid,
        data: dataEnc,
        register: registerId,
        customerInfo: {
          name,
          phoneNumber,
          sessionId,
          userId: currentUserInfo.sub,
        },
        cardId:
          JSON.parse(
            currentUserInfo?.attributes?.['custom:card_collection'] || 0
          )?.[guid?.toLowerCase()] || 0,
        tipsPercentage: 0,
        orderItems: choosenProducts,
        pickupTime,
        useNewCard,
        updateActiveCard,
        useCustomerCard,
      },
      withToken
    )

    const customerPayload = {
      customerName: name,
      phoneNumber,
    }
    const isSupportedBrowser = await isSupported()
    if (isSupportedBrowser && 'Notification' in window) {
      const currentPermission = window.Notification.permission
      if (currentPermission === 'granted') {
        await subscribeForNotifications(customerPayload)
      }
    }

    return result
  }
}
